(function () {
'use strict';
var win = document.querySelector('.pw-win[data-window="record"]');
if (!win || win.__rp6) return; win.__rp6 = 1;
var ROOT = win.closest('.pw') || document;
var body = win.querySelector('.pw-win__body');
var bar = win.querySelector('.pw-win__bar');
if (!body || !bar) return;

/* ---------- tracks: the world's own Parade Track list ---------- */
var TRACKS = Array.prototype.slice.call(ROOT.querySelectorAll('.pw-track')).map(function (b) {
  return { title: b.dataset.title || b.textContent.trim(), artist: b.dataset.artist || '', src: b.dataset.audio };
}).filter(function (t) { return t.src; });

/* Nov 3 2026: one thing plays at a time - a projector tape (or anything else) sends parade:hush and the record pauses */
window.addEventListener('parade:hush', function () { if (playing) togglePlay(); });
try { sessionStorage.removeItem('parade-player'); } catch (e) {}

/* ---------- build the machine inside the world's window ---------- */
win.classList.add('rp6');
var big = document.createElement('button');
big.type = 'button'; big.className = 'r6-min'; big.setAttribute('aria-label', 'Minimise the record player'); big.title = 'Minimise';
big.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 12h12"/></svg>';
var closeBtn = bar.querySelector('.pw-win__close');
bar.insertBefore(big, closeBtn || null);

var m = document.createElement('div');
m.className = 'r6-m';
m.innerHTML =
  '<div class="r6-display">' +
    '<div class="r6-screen" data-view="list">' +
      '<canvas></canvas>' +
      '<div class="r6-top">' +
        '<button type="button" class="r6-back" aria-label="Back to the records" hidden><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M11 6l-6 6 6 6"/></svg></button>' +
        '<i class="r6-lamp"></i><span class="r6-lbl">Parade Music</span>' +
        '<div class="r6-right"><span class="r6-count" hidden>-0:00</span><button type="button" class="r6-chip" hidden>Playing</button></div>' +
      '</div>' +
      '<ol class="r6-list"></ol>' +
      '<div class="r6-flash"></div>' +
    '</div>' +
    '<div class="r6-strip" title="Slide for volume"><div class="r6-s"><b>Choose a record</b></div>' +
      '<div class="r6-vol" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></div><div class="r6-flash"></div></div>' +
  '</div>' +
  '<div class="r6-deck">' +
    '<div class="r6-well"></div><div class="r6-disc"><div class="r6-label"><i></i></div></div><div class="r6-sheen"></div>' +
    '<button type="button" class="r6-play" aria-label="Play">' +
      '<svg class="ic-play" viewBox="0 0 24 24"><path d="M7 4.5v15l13-7.5z" fill="currentColor"/></svg>' +
      '<svg class="ic-pause" viewBox="0 0 24 24"><path d="M6 4.5h4.2v15H6zM13.8 4.5H18v15h-4.2z" fill="currentColor"/></svg>' +
    '</button>' +
  '</div>' +
  '<div class="r6-grille" aria-hidden="true"></div>';
body.appendChild(m);

var reopen = document.createElement('div');
reopen.className = 'r6-reopen'; reopen.setAttribute('role', 'group'); reopen.setAttribute('aria-label', 'The record player, minimised');
reopen.innerHTML =
'<button type="button" class="r6-cap-open" aria-label="Open the record player"><span class="mini"></span><span class="mt"></span></button>' +
'<button type="button" class="r6-cap-play" aria-label="Play"><svg class="ic-play" viewBox="0 0 24 24"><path d="M7 4.5v15l13-7.5z" fill="currentColor"/></svg><svg class="ic-pause" viewBox="0 0 24 24"><path d="M6 4.5h4.2v15H6zM13.8 4.5H18v15h-4.2z" fill="currentColor"/></svg></button>' +
'<button type="button" class="r6-cap-x" aria-label="Stop the music and close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M7 7l10 10M17 7L7 17"/></svg></button>';
document.body.appendChild(reopen);
var capOpen = reopen.querySelector('.r6-cap-open'), capPlay = reopen.querySelector('.r6-cap-play'), capX = reopen.querySelector('.r6-cap-x');

function q(s) { return m.querySelector(s); }
var screenEl = q('.r6-screen'), listEl = q('.r6-list'), backBtn = q('.r6-back'), lamp = q('.r6-lamp'), countEl = q('.r6-count'),
    nowChip = q('.r6-chip'), strip = q('.r6-strip'), stext = q('.r6-s'), volEl = q('.r6-vol'), deck = q('.r6-deck'),
    disc = q('.r6-disc'), playBtn = q('.r6-play'), flashA = q('.r6-screen .r6-flash'), flashB = q('.r6-strip .r6-flash'), cv = q('canvas');

/* ---------- size: the whole machine always fits the world's height ---------- */
var isBig = false;
function size() {
  var r = (ROOT.getBoundingClientRect ? ROOT.getBoundingClientRect() : { top: 0, height: innerHeight });
  var vh = (window.visualViewport && visualViewport.height) || innerHeight;
  var top = Math.max(r.top, 0), h = Math.min(r.top + r.height, vh) - top;
  if (!(h > 200)) h = vh;
  var vw = document.documentElement.clientWidth || innerWidth;
  /* 0.765 = the size Athul marked, Oct 7 2026 */
var w = Math.min(306, vw - 28, (h - 24) / 1.96 * 0.765);
win.style.setProperty('--w', Math.max(200, Math.round(w)) + 'px');
}
size();
addEventListener('resize', size);
if (window.visualViewport) visualViewport.addEventListener('resize', size);
big.addEventListener('click', function () { minimise(); });
function nudgeIntoView() {
  /* when the machine grows, lift it so its foot stays on screen */
  var r = win.getBoundingClientRect(), vh = (window.visualViewport && visualViewport.height) || innerHeight;
  var over = r.bottom - (vh - 10);
  if (over > 0) { var t = parseFloat(win.style.top) || win.offsetTop; win.style.top = Math.max(0, t - over) + 'px'; }
}

/* ---------- state ---------- */
var cur = -1, mode = 'none', loaded = false, loading = false, playing = false, dur = 0, pos = 0, ready = false;
var volume = 0.8; try { var sv = parseFloat(localStorage.getItem('pr-vol')); if (sv >= 0 && sv <= 1) volume = sv; } catch (e) {}
var W0 = 2 * Math.PI * (100 / 3) / 60;
var ang = 0, om = 0, held = false, dragAcc = 0, lastA = 0, rate = 0, sentRate = NaN;

/* ---------- audio engine: variable-rate, reversible playback ---------- */
var WORKLET = 'class D extends AudioWorkletProcessor{' +
'constructor(){super();this.L=null;this.R=null;this.n=0;this.p=0;this.r=0;this.tr=0;this.k=1;this.c=0;this.ended=false;' +
'this.port.onmessage=e=>{const d=e.data;' +
' if(d.L){this.L=d.L;this.R=d.R;this.n=d.L.length;this.k=d.sr/sampleRate;this.p=0;this.ended=false;}' +
' if(d.r!==undefined)this.tr=d.r;' +
' if(d.seek!==undefined){this.p=Math.max(0,d.seek)*d.sr0;this.ended=false;}' +
' if(d.clear){this.L=null;}};}' +
'process(i,o){const a=o[0][0],b=o[0][1]||a,m=a.length;' +
' if(!this.L){a.fill(0);if(b!==a)b.fill(0);return true;}' +
' const L=this.L,R=this.R,n=this.n-2;' +
' for(let k=0;k<m;k++){' +
'  this.r+=(this.tr-this.r)*0.004;' +
'  let p=this.p;if(p>n)p=n;' +
'  const j=p|0,f=p-j,ar=Math.abs(this.r);' +
'  let g=ar<0.03?ar/0.03:1; if(ar>4)g/=1+(ar-4)*0.1;' +
'  a[k]=(L[j]+(L[j+1]-L[j])*f)*g; b[k]=(R[j]+(R[j+1]-R[j])*f)*g;' +
'  this.p+=this.r*this.k; if(this.p<0)this.p=0;' +
' }' +
' if(this.p>=n&&this.r>0&&!this.ended){this.ended=true;this.port.postMessage({end:1});}' +
' if((this.c+=m)>=1024){this.c=0;this.port.postMessage({t:this.p/this.k/sampleRate});}' +
' return true;}}' +
'registerProcessor("parade-deck",D);';

var ac = null, node = null, an = null, vol = null, crG = null, freq = null, bufSR = 44100, booting = null;
var ha = new Audio(); ha.crossOrigin = 'anonymous'; ha.preload = 'auto'; try { ha.setAttribute('playsinline', ''); } catch (e) {}
var haSrc = null, loadToken = 0;
ha.volume = volume * volume;
try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
/* iPhone and iPad mute Web Audio with the silent switch unless an ordinary audio
   element is playing too. A tiny silent loop keeps the page on the media channel. */
var keep = new Audio();
(function () {
  var n = 4000, b = new Uint8Array(44 + n), v = new DataView(b.buffer), i;
  function str(o, t) { for (var k = 0; k < t.length; k++) b[o + k] = t.charCodeAt(k); }
  str(0, 'RIFF'); v.setUint32(4, 36 + n, true); str(8, 'WAVEfmt '); v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
  v.setUint32(24, 8000, true); v.setUint32(28, 8000, true); v.setUint16(32, 1, true); v.setUint16(34, 8, true); str(36, 'data'); v.setUint32(40, n, true);
  for (i = 44; i < b.length; i++) b[i] = 128;
  var bin = ''; for (i = 0; i < b.length; i++) bin += String.fromCharCode(b[i]);
  keep.src = 'data:audio/wav;base64,' + btoa(bin); keep.loop = true; keep.preload = 'auto';
  try { keep.setAttribute('playsinline', ''); } catch (e) {}
})();
function keepAlive(on) { try { if (on) { var p = keep.play(); if (p && p.catch) p.catch(function () {}); } else keep.pause(); } catch (e) {} }

function boot() {
  if (ac) { if (ac.state !== 'running') return ac.resume().catch(function () {}); return Promise.resolve(); }
  if (booting) return booting;
  try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
  ac = new (window.AudioContext || window.webkitAudioContext)({ latencyHint: 'interactive' });
  an = ac.createAnalyser(); an.fftSize = 2048; an.smoothingTimeConstant = 0.7;
  vol = ac.createGain(); vol.gain.value = volume * volume;
  an.connect(vol); vol.connect(ac.destination);
  freq = new Uint8Array(an.frequencyBinCount);
  var cr = ac.createBufferSource(); cr.buffer = crackle(ac); cr.loop = true;
  var hp = ac.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 900;
  crG = ac.createGain(); crG.gain.value = 0; cr.connect(hp); hp.connect(crG); crG.connect(vol); cr.start();
  var resumed = ac.resume().catch(function () {});
  booting = (function () {
    var url;
    try { url = URL.createObjectURL(new Blob([WORKLET], { type: 'application/javascript' })); } catch (e) {}
    if (!ac.audioWorklet || !url) return Promise.resolve(fallback());
    return ac.audioWorklet.addModule(url).then(function () {
      node = new AudioWorkletNode(ac, 'parade-deck', { numberOfInputs: 0, outputChannelCount: [2] });
    }).catch(function () { fallback(); });
  })().then(function () {
    node.connect(an);
    node.port.onmessage = function (e) {
      if (e.data.t !== undefined && mode === 'buf') pos = e.data.t;
      if (e.data.end && mode === 'buf') { node.port.postMessage({ clear: 1 }); next(); }
    };
    return resumed;
  });
  return booting;
}
function fallback() {
  /* the same processor, run on the page when worklets are blocked */
  var Proc, proc, mainPort = { onmessage: null, postMessage: function (msg) { proc.port.onmessage({ data: msg }); } };
  function Base() { this.port = { onmessage: null, postMessage: function (msg) { mainPort.onmessage && mainPort.onmessage({ data: msg }); } }; }
  new Function('AudioWorkletProcessor', 'registerProcessor', 'sampleRate', WORKLET)(Base, function (n, c) { Proc = c; }, ac.sampleRate);
  proc = new Proc();
  var sp = ac.createScriptProcessor(1024, 1, 2);
  sp.onaudioprocess = function (e) { proc.process([], [[e.outputBuffer.getChannelData(0), e.outputBuffer.getChannelData(1)]]); };
  node = { port: mainPort, connect: function (d) { sp.connect(d); } };
}
function crackle(c) {
  var n = c.sampleRate * 3, b = c.createBuffer(1, n, c.sampleRate), d = b.getChannelData(0), i, k;
  for (i = 0; i < n; i++) {
    d[i] += (Math.random() * 2 - 1) * 0.03;
    if (Math.random() < 0.0005) { var a = (Math.random() * 2 - 1) * 0.9; for (k = 0; k < 30 && i + k < n; k++) d[i + k] += a * Math.exp(-k / 5); }
  }
  return b;
}

/* stream at once, then hand over to the scratchable buffer when the whole song has arrived */
ha.addEventListener('loadedmetadata', function () { if (mode === 'stream' && isFinite(ha.duration)) dur = ha.duration; });
ha.addEventListener('playing', function () { if (mode === 'stream') { loading = false; ready = true; setPagerTrack(); ui(); } });
ha.addEventListener('ended', function () { if (mode === 'stream') next(); });
ha.addEventListener('error', function () { if (mode === 'stream' && !loaded) { loading = false; pagerTemp('That file will not play', '', 2200); ui(); } });

function next() { if (TRACKS.length) loadTrack((cur + 1) % TRACKS.length, true); }

function loadTrack(i, autoplay) {
  var token = ++loadToken;
  cur = i; mode = 'stream'; loaded = false; ready = false; loading = true; pos = 0; dur = 0;
  if (autoplay) { playing = true; keepAlive(true); }
  if (node) node.port.postMessage({ clear: 1 });
  var t = TRACKS[i];
  ha.src = t.src;
  if (playing) { var pr = ha.play(); if (pr && pr.catch) pr.catch(function () {}); }
  setPager('Loading', ''); setView('now'); ui(); renderOn();
  boot().then(function () {
    return fetch(t.src, { mode: 'cors' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.arrayBuffer(); });
  }).then(function (ab) {
    return new Promise(function (res, rej) { var p = ac.decodeAudioData(ab, res, rej); if (p && p.then) p.then(res, rej); });
  }).then(function (buf) {
    if (token !== loadToken) return;
    var L = buf.getChannelData(0).slice(), R = (buf.numberOfChannels > 1 ? buf.getChannelData(1) : buf.getChannelData(0)).slice();
    bufSR = buf.sampleRate; dur = buf.duration;
    node.port.postMessage({ L: L, R: R, sr: buf.sampleRate }, [L.buffer, R.buffer]);
    var at = mode === 'stream' ? (ha.currentTime || 0) : 0;
    pos = at;
    node.port.postMessage({ seek: at, sr0: bufSR });
    mode = 'buf'; loaded = true; ready = true; loading = false;
    sentRate = playing ? 1 : 0; node.port.postMessage({ r: sentRate });
    try { ha.pause(); } catch (e) {}
    var p0 = at;
    setTimeout(function () {
      if (token !== loadToken || mode !== 'buf' || !playing || held) return;
      if (ac.state !== 'running' || pos - p0 < 0.3) {
        /* the scratch engine is not running on this device: carry on with the plain stream */
        mode = 'stream'; loaded = false;
        try { node.port.postMessage({ clear: 1 }); ha.currentTime = pos; } catch (e) {}
        var pr2 = ha.play(); if (pr2 && pr2.catch) pr2.catch(function () {});
      }
    }, 1500);
    setPagerTrack(); ui();
  }).catch(function () {
    /* the stream keeps playing; only scratching is unavailable */
    if (token === loadToken && !ready) { loading = false; pagerTemp('That file will not play', '', 2200); ui(); }
  });
}
function seek(s) {
  if (!ready || !dur) return;
  pos = Math.max(0, Math.min(dur - 0.05, s));
  if (mode === 'buf') node.port.postMessage({ seek: pos, sr0: bufSR }); else try { ha.currentTime = pos; } catch (e) {}
}

/* ---------- e-ink panel: static text that page-flips, never scrolls ---------- */
var tempUntil = 0;
function flash(el) { el.classList.remove('go'); void el.offsetWidth; el.classList.add('go'); }
function setPager(title, artist) {
  var k = title + '|' + artist; if (stext.dataset.k === k) return; stext.dataset.k = k;
  stext.innerHTML = '<b></b>' + (artist ? ' <span></span>' : '');
  stext.querySelector('b').textContent = title; if (artist) stext.querySelector('span').textContent = '  ' + artist;
  flash(flashB);
}
function setPagerTrack() { var t = TRACKS[cur]; if (loading) setPager('Loading', ''); else if (t) setPager(t.title, t.artist); else setPager(TRACKS.length ? 'Choose a record' : 'No records yet', ''); }
function pagerTemp(title, artist, ms) { setPager(title, artist); tempUntil = performance.now() + ms; }
function setView(v) { if (screenEl.dataset.view === v) return; screenEl.dataset.view = v; flash(flashA); ui(); }
function drawVol() { Array.prototype.forEach.call(volEl.children, function (b, i) { b.classList.toggle('on', volume >= (i + 1) / 6 - 0.001); }); }
function setVolume(v) {
  volume = Math.max(0, Math.min(1, v));
  if (vol) vol.gain.setTargetAtTime(volume * volume, ac.currentTime, 0.02);
  ha.volume = volume * volume;
  try { localStorage.setItem('pr-vol', volume); } catch (e) {}
  drawVol(); pagerTemp('Volume ' + Math.round(volume * 100), '', 1000);
}
var volDrag = null;
strip.addEventListener('pointerdown', function (e) { volDrag = { x: e.clientX, v: volume }; try { strip.setPointerCapture(e.pointerId); } catch (err) {} e.stopPropagation(); e.preventDefault(); });
strip.addEventListener('pointermove', function (e) {
  if (!volDrag) return;
  var nv = Math.round((volDrag.v + (e.clientX - volDrag.x) / (strip.clientWidth * 0.8)) * 20) / 20;
  if (nv !== volume) setVolume(nv);
});
function endVol() { volDrag = null; }
strip.addEventListener('pointerup', endVol); strip.addEventListener('pointercancel', endVol);

/* ---------- the list of records ---------- */
function renderList() {
  listEl.innerHTML = '';
  if (!TRACKS.length) { listEl.innerHTML = '<li class="r6-empty">No records on the shelf yet.</li>'; return; }
  TRACKS.forEach(function (t, i) {
    var li = document.createElement('li'), b = document.createElement('button');
    b.type = 'button'; b.className = 'r6-trk';
    b.innerHTML = '<span class="n">' + String(i + 1).padStart(2, '0') + '</span><span class="t"></span><span class="a"></span>';
    b.querySelector('.t').textContent = t.title; b.querySelector('.a').textContent = t.artist;
    b.addEventListener('click', function () {
      if (i === cur && ready) { if (!playing) togglePlay(); setView('now'); ui(); }
      else loadTrack(i, true);
    });
    li.appendChild(b); listEl.appendChild(li);
  });
}
function renderOn() { Array.prototype.forEach.call(listEl.querySelectorAll('.r6-trk'), function (b, i) { b.classList.toggle('is-on', i === cur); }); }

/* ---------- ui ---------- */
function fmt(s) { s = Math.max(0, Math.ceil(s)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }
function ui() {
  var now = screenEl.dataset.view === 'now';
  win.classList.toggle('is-playing', playing && (ready || loading));
  playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
  lamp.className = 'r6-lamp' + (loading ? ' wait' : (playing && ready ? ' on' : ''));
  countEl.hidden = !(ready && now && dur);
  backBtn.hidden = !now;
  nowChip.hidden = !((ready || loading) && !now); nowChip.textContent = playing ? 'Playing' : 'Paused';
  renderOn();
  reopen.classList.toggle('is-spinning', playing && ready);
reopen.classList.toggle('is-playing', playing);
capPlay.setAttribute('aria-label', playing ? 'Pause' : 'Play');
  reopen.querySelector('.mt').textContent = cur >= 0 ? TRACKS[cur].title : 'The Record Player';
  showPill();
}
function togglePlay() {
  boot();
  playing = !playing;
  keepAlive(playing);
  if (mode === 'stream') { if (playing) { var p = ha.play(); if (p && p.catch) p.catch(function () {}); } else ha.pause(); }
  if (mode === 'buf' && node) { sentRate = playing ? 1 : 0; node.port.postMessage({ r: sentRate }); }
  ui();
  try { navigator.vibrate && navigator.vibrate(8); } catch (e) {}
}
backBtn.addEventListener('click', function () { setView('list'); });
nowChip.addEventListener('click', function () { setView('now'); });
playBtn.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
playBtn.addEventListener('click', function () {
  if (!TRACKS.length) return;
  if (cur < 0 || (!ready && !loading)) { loadTrack(cur < 0 ? 0 : cur, true); return; }
  togglePlay();
});

/* ---------- the record: scratch, scrub and fling ---------- */
function centre() { var r = disc.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2, r: r.width / 2 }; }
function angleOf(e) { var c = centre(); return Math.atan2(e.clientY - c.y, e.clientX - c.x); }
deck.addEventListener('pointerdown', function (e) {
  var c = centre(); if (Math.hypot(e.clientX - c.x, e.clientY - c.y) > c.r * 1.03) return;
  e.preventDefault(); e.stopPropagation(); boot();
  held = true; dragAcc = 0; lastA = angleOf(e); try { deck.setPointerCapture(e.pointerId); } catch (err) {} deck.classList.add('is-held');
});
deck.addEventListener('pointermove', function (e) {
  if (!held) return;
  var a = angleOf(e), d = a - lastA; d = ((d + Math.PI) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI) - Math.PI;
  dragAcc += d; lastA = a;
});
function release() { held = false; deck.classList.remove('is-held'); }
deck.addEventListener('pointerup', release); deck.addEventListener('pointercancel', release);
deck.addEventListener('wheel', function (e) { e.preventDefault(); e.stopPropagation(); boot(); om += Math.max(-40, Math.min(40, e.deltaY)) * 0.06; }, { passive: false });
/* the window is a place in the world: touches on it never drag the world */
['pointerdown', 'touchstart', 'touchmove', 'wheel'].forEach(function (t) { m.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true }); });
function toRate(w) { var r = w / W0, a = Math.abs(r), g = a > 1.6 ? 1 + 0.32 * Math.pow(a - 1.6, 1.5) : 1; return Math.max(-60, Math.min(60, r * g)); }

/* ---------- sonogram on e-ink: the song painted round a circle ---------- */
var gl = null; try { gl = cv.getContext('webgl', { antialias: false, premultipliedAlpha: false }); } catch (e) {}
var U = {}, HN = 1024, HB = 128, hist = new Uint8Array(HN * HB), histTex, lastCol = -1, lastHistTrack = -1;
if (gl) {
  var vs = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  var fs = [
    'precision highp float;',
    'uniform sampler2D H;uniform vec2 R;uniform float T,P,K,Bs,A,Sc;',
    'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p),u=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),u.x),mix(h(i+vec2(0,1)),h(i+vec2(1,1)),u.x),u.y);}',
    'float smp(float f,float t){return texture2D(H,vec2(fract(f),t)).r;}',
    'void main(){',
    ' vec2 uv=(gl_FragCoord.xy-.5*R)/R.y;',
    ' float r=length(uv)/.42;',
    ' float f=fract(atan(uv.x,uv.y)/6.28318);',
    ' float r0=.2,t=(r-r0)/(1.-r0);',
    ' float v=0.;',
    ' if(t>0.&&t<1.){v=smp(f,t)*.46+smp(f+.001,t)*.27+smp(f-.001,t)*.27;}',
    ' float lo=smp(f,.06);',
    ' float edge=1.+.1*lo+.03*Bs;',
    ' v*=smoothstep(edge+.02,edge-.08,r);',
    ' float sp=n(uv*150.+T*.05)*.6+n(uv*480.+T*.08)*.4;',
    ' float streak=n(vec2(f*360.,t*7.));',
    ' v=v*(.5+1.0*sp)*(.7+.6*streak);',
    ' v=pow(max(v,0.),.85)*1.3;',
    ' float e1=(r-.46)*130.,e2=(r-.73)*130.,e3=(r-1.)*170.;',
    ' float g=exp(-e1*e1)*.12+exp(-e2*e2)*.12+exp(-e3*e3)*.6;',
    ' float idle=(1.-A)*.08*n(uv*40.+T*.02)*smoothstep(1.,.95,r)*step(r0,r);',
    ' float a=clamp(v+g+idle,0.,1.);',
    ' a=floor(a*15.+h(gl_FragCoord.xy))/15.;',
    ' vec3 paper=vec3(.831,.82,.784),pig=vec3(.11,.098,.09),ox=vec3(.486,.082,.07);',
    ' vec3 c=mix(paper,pig,a*.92);',
    ' float d=abs(fract(f-P+.5)-.5);',
    ' float sweep=step(d,.0022)*smoothstep(r0-.04,r0,r)*smoothstep(1.06,1.02,r);',
    ' float dt=step(r,.055+.04*K);',
    ' c=mix(c,ox,max(sweep,dt));',
    ' c=mix(c,ox,Sc*.5*step(h(floor(gl_FragCoord.xy/2.)),.35)*smoothstep(1.,.3,r)*step(r0,r));',
    ' gl_FragColor=vec4(c,1.);}'
  ].join('\n');
  var sh = function (t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; };
  var pr = gl.createProgram(); gl.attachShader(pr, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(pr);
  if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) gl = null;
  else {
    gl.useProgram(pr);
    var vb = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, vb); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    ['R', 'T', 'P', 'K', 'Bs', 'A', 'Sc', 'H'].forEach(function (k) { U[k] = gl.getUniformLocation(pr, k); });
    histTex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, histTex);
    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, HN, HB, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, hist);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.uniform1i(U.H, 0);
  }
}
var vT = 0, bass = 0, beat = 0, bassAvg = 0, lastBeat = 0, act = 0, scr = 0, lastDraw = 0, binCol = new Uint8Array(HB);
function band(a, b) { var s = 0; for (var i = a; i < b; i++) s += freq[i]; return s / ((b - a) * 255); }
function paintColumn() {
  var hzb = ac.sampleRate / an.fftSize, fmin = 35, fmax = 14000, k, i;
  for (k = 0; k < HB; k++) {
    var f0 = fmin * Math.pow(fmax / fmin, k / HB), f1 = fmin * Math.pow(fmax / fmin, (k + 1) / HB);
    var i0 = Math.max(1, Math.floor(f0 / hzb)), i1 = Math.max(i0 + 1, Math.ceil(f1 / hzb)), mx = 0;
    for (i = i0; i < i1 && i < freq.length; i++) if (freq[i] > mx) mx = freq[i];
    binCol[k] = Math.min(255, Math.pow(mx / 255, 1.4) * 255 * (0.75 + 0.6 * (k / HB)));
  }
  var col = Math.max(0, Math.min(HN - 1, Math.floor((dur ? pos / dur : 0) * HN)));
  var from = lastCol < 0 ? col : lastCol; if (Math.abs(col - from) > HN / 2) from = col;
  var step = col >= from ? 1 : -1;
  for (var c = from; ; c += step) { for (k = 0; k < HB; k++) { var ix = k * HN + c; hist[ix] = Math.max(binCol[k], hist[ix] * 0.35 | 0); } if (c === col) break; }
  lastCol = col;
}
function drawViz(now, dt) {
  if (!gl || win.hidden) return;
  var W = cv.clientWidth | 0, H = cv.clientHeight | 0;
  if (!W || !H) return;
  if (cv.width !== W || cv.height !== H) { cv.width = W; cv.height = H; gl.viewport(0, 0, W, H); }
  if (cur !== lastHistTrack) { for (var i = 0; i < hist.length; i++) hist[i] = hist[i] * 0.22 | 0; lastCol = -1; lastHistTrack = cur; }
  var b = 0;
  if (an && loaded) {
    an.getByteFrequencyData(freq); var hzb = ac.sampleRate / an.fftSize; b = band(1, Math.ceil(170 / hzb));
    var moving = mode === 'buf' && Math.abs(rate) > 0.02;
    if (moving) paintColumn();
  }
  bass += (b - bass) * Math.min(1, dt * 14); bassAvg += (b - bassAvg) * Math.min(1, dt * 1.5);
  if (b > bassAvg * 1.25 && b > 0.3 && now - lastBeat > 220) { beat = 1; lastBeat = now; }
  beat *= Math.exp(-dt * 3.2);
  vT += dt;
  act += (((playing && ready) || held ? 1 : 0) - act) * Math.min(1, dt * 2);
  scr += ((((held || Math.abs(rate - 1) > 0.6) && loaded) ? Math.min(1, Math.abs(rate - 1) * 0.5) : 0) - scr) * Math.min(1, dt * 8);
  if (now - lastDraw < 83) return; lastDraw = now;
  gl.bindTexture(gl.TEXTURE_2D, histTex); gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, HN, HB, gl.LUMINANCE, gl.UNSIGNED_BYTE, hist);
  var P = ready && dur ? pos / dur : (vT * 0.03) % 1;
  gl.uniform2f(U.R, W, H); gl.uniform1f(U.T, vT); gl.uniform1f(U.P, P); gl.uniform1f(U.K, beat); gl.uniform1f(U.Bs, bass);
  gl.uniform1f(U.A, act); gl.uniform1f(U.Sc, scr);
  gl.drawArrays(gl.TRIANGLES, 0, 3);
}

/* ---------- main loop: the platter is the clock ---------- */
var last = performance.now();
function frame(now) {
  var dt = Math.min(0.05, (now - last) / 1000); last = now;
  if (held) { var inst = dragAcc / Math.max(dt, 1 / 240); dragAcc = 0; om += (inst - om) * Math.min(1, dt * 28); }
  else {
    var tgt = playing && ready ? W0 : 0;
    var k = tgt ? (Math.abs(om) > W0 * 1.6 ? 1.4 : 6.5) : (Math.abs(om) > W0 * 1.6 ? 1.6 : 2.8);
    om += (tgt - om) * (1 - Math.exp(-dt * k)); if (!tgt && Math.abs(om) < 0.02) om = 0;
  }
  ang += om * dt;
  if (!win.hidden) disc.style.transform = 'rotate(' + ang + 'rad)';
  rate = mode === 'buf' ? toRate(om) : (playing ? 1 : 0);
  if (mode === 'buf' && node && Math.abs(rate - sentRate) > 0.0008) { node.port.postMessage({ r: rate }); sentRate = rate; }
  if (mode === 'stream') { pos = ha.currentTime || 0; if (!dur && isFinite(ha.duration)) dur = ha.duration; }
  if (crG) { var a = Math.min(1, Math.abs(om) / W0); crG.gain.setTargetAtTime(ready ? (0.02 * a + (held && loaded ? Math.min(0.05, Math.abs(rate - 1) * 0.012) : 0)) : 0, ac.currentTime, 0.03); }
  if (ready && dur) { var c = '-' + fmt(dur - pos); if (countEl.textContent !== c) countEl.textContent = c; }
  if (tempUntil && now > tempUntil) { tempUntil = 0; setPagerTrack(); }
  drawViz(now, dt);
  /* rest when closed and silent (Oct 14 2026) */
  if (win.hidden && !playing && !held && !om) { rpSleep = true; return; }
  requestAnimationFrame(frame);
}
var rpSleep = false;
function rpWake() { if (rpSleep) { rpSleep = false; last = performance.now(); requestAnimationFrame(frame); } }
new MutationObserver(rpWake).observe(win, { attributes: true, attributeFilter: ['hidden'] });
document.addEventListener('pointerdown', rpWake, true); document.addEventListener('keydown', rpWake, true);

/* ---------- keyboard, only while the player is open ---------- */
addEventListener('keydown', function (e) {
  if (win.hidden) return;
  var t = e.target, tag = t && t.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || (t && t.isContentEditable)) return;
  if (t !== document.body && !win.contains(t)) return;
  if (e.code === 'Space' && !(t && t.tagName === 'BUTTON')) { e.preventDefault(); playBtn.click(); }
  else if (e.key === 'ArrowRight' && win.contains(t)) { e.preventDefault(); seek(pos + 10); }
  else if (e.key === 'ArrowLeft' && win.contains(t)) { e.preventDefault(); seek(pos - 10); }
  else if (e.key === 'ArrowUp' && win.contains(t)) { e.preventDefault(); setVolume(volume + 0.05); }
  else if (e.key === 'ArrowDown' && win.contains(t)) { e.preventDefault(); setVolume(volume - 0.05); }
});

/* ---------- minimise keeps the music in the footer capsule; close stops it ---------- */
var minimised = false, wasHidden = !!win.hidden;
function placeCap() {
var f = document.querySelector('.pr-foot');
if (f && reopen.parentNode !== f) f.appendChild(reopen);
reopen.classList.toggle('in-foot', !!f && reopen.parentNode === f);
}
function showPill() {
placeCap();
var on = !!win.hidden && minimised && cur >= 0;
reopen.classList.toggle('is-on', on);
var f = document.querySelector('.pr-foot'); if (f) f.classList.toggle('r6-capped', on);
}
function stopMusic() {
minimised = false;
playing = false; keepAlive(false);
try { ha.pause(); } catch (e) {}
om = 0; if (node) { sentRate = 0; node.port.postMessage({ r: 0 }); }
if (ready) seek(0);
setView('list'); ui();
}
function minimise() { minimised = true; if (closeBtn) closeBtn.click(); else win.hidden = true; showPill(); }
new MutationObserver(function () {
var h = !!win.hidden;
if (h && !wasHidden && !minimised) stopMusic();
if (!h && wasHidden) minimised = false;
wasHidden = h;
showPill(); if (!h) size();
}).observe(win, { attributes: true, attributeFilter: ['hidden', 'class'] });
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeCap); else setTimeout(placeCap, 0);
addEventListener('load', placeCap);
capPlay.addEventListener('click', function () {
if (cur < 0) return;
if (!ready && !loading) { loadTrack(cur, true); return; }
togglePlay();
});
capX.addEventListener('click', function () { stopMusic(); showPill(); });
capOpen.addEventListener('click', function () {
  var obj = ROOT.querySelector('.pw__object[data-opens="record"]');
  if (obj) {
    var r = obj.getBoundingClientRect(), o = { bubbles: true, cancelable: true, clientX: r.left + 2, clientY: r.top + 2, button: 0, pointerId: 77, isPrimary: true, pointerType: 'mouse' };
    try { obj.dispatchEvent(new PointerEvent('pointerdown', o)); window.dispatchEvent(new PointerEvent('pointerup', o)); } catch (e) {}
    obj.click();
  }
  setTimeout(function () {
    if (win.hidden) { win.hidden = false; requestAnimationFrame(function () { win.classList.add('is-open'); }); }
  }, 120);
});

document.addEventListener('visibilitychange', function () {
  if (mode === 'buf' && node && !held) { om = playing ? W0 : 0; sentRate = playing ? 1 : 0; node.port.postMessage({ r: sentRate }); }
});
window.__rp6 = function () { return { ac: ac && ac.state, mode: mode, loaded: loaded, ready: ready, playing: playing, pos: +pos.toFixed(2), dur: +dur.toFixed(1), gl: !!gl }; };
renderList(); drawVol(); setPagerTrack(); ui();
requestAnimationFrame(frame);
})();
